import { combineReducers } from "redux"
import { loadingBarReducer } from "react-redux-loading-bar"
// import { routerReducer } from "redux-first-routing"
import UserReducer from "./reducer_user"
import ProjectReducer from "./reducer_project"
import CommunityReducer from "./reducer_community"
import FileReducer from "./reducer_file"
import AssignmentReducer from "./reducer_assignment"
import TourReducer from "./reducer_tour"
import AdvancedSearchReducer from "./reducer_advancedsearch"
import HistoryReducer from "./reducer_history"
import NotificationReducer from "./reducer_notification"
import BlogsReducer from "./reducer_blogs"

const rootReducer = combineReducers({
	loadingBar: loadingBarReducer,
	UserReducer: UserReducer,
	ProjectReducer: ProjectReducer,
	CommunityReducer: CommunityReducer,
	FileReducer: FileReducer,
	AssignmentReducer: AssignmentReducer,
	AdvancedSearchReducer: AdvancedSearchReducer,
	TourReducer: TourReducer,
	HistoryReducer: HistoryReducer,
	NotificationReducer: NotificationReducer,
	BlogsReducer: BlogsReducer
})

export default rootReducer
